import React, { useState } from "react";

import "./App.css";
import "./index.css";

import Landing from "./components/Landing";
import Scene from "./components/Scene";

const App = ({ controlsSettings, cameraSettings, models, landingText }) => {
  const [hasUserConsent, setHasUserConsent] = useState(true);

  return (
    <>
      {hasUserConsent ? (
        <Scene
          controlsSettings={controlsSettings}
          cameraSettings={cameraSettings}
          models={models}
        />
      ) : (
        <Landing
          onConsent={() => setHasUserConsent(true)}
          textContent={landingText}
          modelUrl={models[0].src}
        />
      )}
    </>
  );
};

export default App;
